module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-13-97ad3da37d1b0e148222e4ab2b7d60c2.jpg";